import FacebookIcon from '@flipster/react/icon-legacy/social/ic-facebook.svg';
import InstagramIcon from '@flipster/react/icon-legacy/social/ic-instagram.svg';
import LinkedInIcon from '@flipster/react/icon-legacy/social/ic-linkedin.svg';
import TelegramIcon from '@flipster/react/icon-legacy/social/ic-telegram.svg';
import XIcon from '@flipster/react/icon-legacy/social/ic-x.svg';
import YoutubeIcon from '@flipster/react/icon-legacy/social/ic-youtube.svg';

export const SnsItems = [
  { label: 'X', icon: XIcon, href: 'https://x.com/flipster_io' },
  { label: 'Telegram', icon: TelegramIcon, href: 'https://t.me/flipster_io' },
  { label: 'Linkedin', icon: LinkedInIcon, href: 'https://www.linkedin.com/company/flipster-official' },
  { label: 'Instagram', icon: InstagramIcon, href: 'https://www.instagram.com/flipster_io' },
  { label: 'Facebook', icon: FacebookIcon, href: 'https://www.facebook.com/FlipsterGlobal' },
  { label: 'Youtube', icon: YoutubeIcon, href: 'https://www.youtube.com/channel/UC_3J-wzFgDu2P8NF_CrjAYg/featured' },
];
